export default __webpack_public_path__ + "static/stanislav-horkusha-dfbd20fd917707ab119645f2a5af9b70.png";